const enviroment = {
  baseUrl : process.env.VUE_APP_BASE_URL,
  apiUrl : process.env.VUE_APP_API_URL,
  baseApiUrl : process.env.VUE_APP_BASE_API_URL,
  EVENTS_API: process.env.VUE_APP_BASE_EVENTS_API,
  BITACORA_TOKEN: process.env.VUE_APP_BASE_BITACORA_TOKEN
};


export default enviroment;